import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import _ from 'lodash';

import * as QuizHelpers from '../../helpers/quiz';
import { updateStepIfDifferent } from '../../helpers/routes';

class Income extends Component {
  constructor (props) {
    super(props);
    this.state = {
      skipStep: false,
      animate: ''
    };
    this._nextStep = this._nextStep.bind(this);
    this._skipStep = this._skipStep.bind(this);
    this._prevStep = this._prevStep.bind(this);
    this._handleIncomeChange = this._handleIncomeChange.bind(this);
  }

  componentDidMount () {
    this.setState({'skipStep': false});

    const p = _.clone(this.props);
    QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, 'Income');
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  checkMedicaidEligible = (strValue, familySize) => {
    const value = parseInt(strValue.replace(/,/g, ''), 10);

    switch (true) {
      case (familySize === '1' && value <= 21597):
        return true;
      case (familySize === '2' && value <= 29187):
        return true;
      case (familySize === '3' && value <= 36777):
        return true;
      case (familySize === '4' && value <= 44367):
        return true;
      case (familySize === '5' && value <= 51957):
        return true;
      case (familySize === '6' && value <= 59547):
        return true;
      case (familySize === '7' && value <= 67137):
        return true;
      case (familySize === '8' && value <= 74727):
        return true;
      default:
        return false;
    }
  };

  checkEssentialEligible = (strValue, familySize) => {
    const value = parseInt(strValue.replace(/,/g, ''), 10);

    switch (true) {
      case (familySize === '1' && value <= 39125):
        return true;
      case (familySize === '2' && value <= 52875):
        return true;
      case (familySize === '3' && value <= 66625):
        return true;
      case (familySize === '4' && value <= 80375):
        return true;
      case (familySize === '5' && value <= 94125):
        return true;
      case (familySize === '6' && value <= 107875):
        return true;
      case (familySize === '7' && value <= 121625):
        return true;
      case (familySize === '8' && value <= 135375):
        return true;
      default:
        return false;
    }
  };

  _handleIncomeChange (income) {
    const formattedValue = income;
    const isMedicaidEligible = this.checkMedicaidEligible(
      income, this.props.quiz.fieldValues.TotalFamilySize);
    const isEssentialEligible = this.checkEssentialEligible(
      income, this.props.quiz.fieldValues.TotalFamilySize);

    this.props.reducer(income);

    if (this.props.route !== 'child-health-plus' || this.props.quiz.FamilyType !== 'ChildrenOnly') {
      if (isMedicaidEligible === true && isEssentialEligible === true) {
        this.props.setFieldValue('Essential', true);
        this.props.setFieldValue('Medicaid', true);
      } else {
        this.props.setFieldValue('Medicaid', false);
      }

      if (isMedicaidEligible === false && isEssentialEligible === true) {
        this.props.setFieldValue('Essential', true);
      }

      if (isMedicaidEligible === false && isEssentialEligible === false) {
        this.props.setFieldValue('Essential', false);
      }
    }

    this.setState({
      'profit': formattedValue,
      'skipStep': false
    });
  }

  _nextStep () {
    const p = _.clone(this.props);
    const {quiz, stepMethods, route} = p;
    const income = quiz.fieldValues.IncomeYearly;
    const isMedicaidEligible = this.checkMedicaidEligible(
      income, this.props.quiz.fieldValues.TotalFamilySize);
    const isEssentialEligible = this.checkEssentialEligible(
      income, this.props.quiz.fieldValues.TotalFamilySize);

    if (this.props.route !== 'child-health-plus' || this.props.FamilyType !== 'ChildrenOnly') {
      if (isMedicaidEligible === true && isEssentialEligible === true) {
        this.props.updateQuote('medicaid');
      }

      if (isMedicaidEligible === false && isEssentialEligible === true) {
        this.props.updateQuote('essential');
      }
    }

    switch (route) {
      case 'essential':
      case 'medicaid':
        if (this.props.quiz.fieldValues.FamilyType === 'ChildrenOnly') {
          stepMethods.setStep(quiz.step + 2);
        } else if (isMedicaidEligible === true) {
          stepMethods.setStep(quiz.step + 3);
        } else if (isEssentialEligible === true) {
          stepMethods.setStep(quiz.step + 4);
        } else {
          stepMethods.setStep(quiz.step + 1);
        }
        break;

      case 'individuals':
        if (isMedicaidEligible === true) {
          stepMethods.setStep(quiz.step + 5);
        } else if (isEssentialEligible === true) {
          stepMethods.setStep(quiz.step + 6);
        } else {
          stepMethods.setStep(quiz.step + 2);
        }
        break;

      case 'families':
        if (this.props.quiz.fieldValues.FamilyType === 'ChildrenOnly') {
          stepMethods.setStep(quiz.step + 3);
        } else if (isMedicaidEligible === true) {
          stepMethods.setStep(quiz.step + 4);
        } else if (isEssentialEligible === true) {
          stepMethods.setStep(quiz.step + 5);
        } else {
          stepMethods.setStep(quiz.step + 1);
        }
        break;

      default:
        stepMethods.setStep(quiz.step + 1);
        break;
    }
  }

  _prevStep () {
    window.history.go(-1);
  }

  _skipStep () {
    const p = _.clone(this.props);
    const {
      stepMethods
    } = p;

    this.setState({'skipStep': true});
    this.props.reducer('');

    stepMethods.nextStep();
  }

  _validate (val = this.props.quiz.fieldValues.IncomeYearly) {
    const isValid = (val.length > 3);
    if (!isValid) updateStepIfDifferent(this.props.quiz.step);
    return isValid;
  }

  render () {
    const p = _.clone(this.props);
    // const CHP = (p.quiz.fieldValues.FamilyType === 'ChildrenOnly');
    let notice;
    let incomeEntered = (this.props.quiz.fieldValues.IncomeYearly.length > 3);
    let isEnabled = true;

    if (!this.state.skipStep) isEnabled = this._validate(p.quiz.fieldValues.IncomeYearly);

    if (p.route !== 'child-health-plus') {
      if (p.route === 'medicaid') {
        if (incomeEntered && p.quiz.fieldValues.Medicaid === false) {
          notice = <p className='info'>You may not be eligible for Medicaid, but please <a href='javascript:void(0);' onClick={this._nextStep}>continue to see another option</a>.</p>;
        }
      }

      if (p.route === 'essential') {
        if (incomeEntered && p.quiz.fieldValues.Essential === false) {
          notice = <p className='info'>You may not be eligible for a New York Essential Plan, but please  <a href='javascript:void(0);' onClick={this._nextStep}>continue to see another option</a>.</p>;
        }
      }
    }

    const Location = this.props.quiz.location.loc.Medicaid;
    const EssentialLocation = this.props.quiz.location.loc.Essential;

    if (incomeEntered && p.quiz.fieldValues.Medicaid === true && !Location) {
      notice = <p className='info'>You may be eligible for Medicaid. Unfortunately, we don&rsquo;t offer Medicaid plans in your area,<br /> but you can always visit the <a href='https://nystateofhealth.ny.gov/' target='_blank' rel='noopener noreferrer'>New York State of Health</a> to find coverage.</p>;
      isEnabled = false;
    } else if (incomeEntered && p.quiz.fieldValues.Medicaid === false && p.quiz.fieldValues.Essential === true && !EssentialLocation) {
      notice = <p className='info'>You may be eligible for a New York Essential Plan. Unfortunately, we don&rsquo;t offer Essential plans in your area,<br /> but you can always visit the <a href='https://nystateofhealth.ny.gov/' target='_blank' rel='noopener noreferrer'>New York State of Health</a> to find coverage.</p>;
      isEnabled = false;
    }

    return <section className={'p30 text-center animate ' + this.state.animate}>
      <div className='wrap'>
        <h3>What will your total {this.props.type === 'family' ? 'family' : 'household'} income be this year?</h3>

        {/* {!(p.quiz.fieldValues.Medicaid || CHP || p.quiz.fieldValues.Essential) ? */}
        {(this.props.route === 'individuals' || this.props.route === 'families') && <p>This helps us identify the most affordable plan for you, including whether you’re eligible<br /> for government-funded discounts and options.</p>}

        <p className='form income-form'>
          <NumberFormat
            value={p.quiz.fieldValues.IncomeYearly}
            thousandSeparator
            isNumericString
            id='income'
            autoFocus
            type='tel'
            decimalScale={0}
            name='IncomeYearly'
            maxLength='8'
            ref={(input) => { this.income = input; }}
            onChange={(e) => this._handleIncomeChange(e.target.value)}
            onKeyUp={(e) => (e.which === 13 && isEnabled && this._nextStep())}
          />
          {this.props.stepMethods.isNextStep() &&
          <button
            className={'btn next ' + isEnabled}
            disabled={!isEnabled}
            onClick={this._nextStep}
          >Next</button>
          }
        </p>
        <button className='btn back' onClick={this._prevStep}>Previous</button>
        <div className={'message' + (notice ? ' show' : '')}>
          {notice}
        </div>
      </div>
    </section>;
  }
}

export default Income;



// WEBPACK FOOTER //
// ./src/components/Questions/Income.jsx